import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, HvlBaseModel } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrPerEmployeeCardsDetailModel')
export class PerEmployeeCardsDetailModel extends HvlBaseModel {
    @EmptyControl()
    @JsonProperty('perEmployeeSubtypeId', Number, true)
    perEmployeeSubtypeId: number = null

    @JsonProperty('perEmployeeCardsId', Number, true)
    perEmployeeCardsId: number = null

    @JsonProperty('employeeSubtypeCodeTextId', Number, true)
    employeeSubtypeCodeTextId: number = null;

    @JsonProperty('perEmployeeTypeText', String, true)
    perEmployeeTypeText: string = null

    @JsonProperty('perEmployeeSubtypeText', String, true)
    perEmployeeSubtypeText: string = null

}
